import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { Notification } from '../classes/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private socket: Socket) { }

  public listen(userId: number): Observable<Notification> {
    return this.socket.fromEvent(`notification:${userId}`)
  }

  public connect() {
    this.socket.connect();
  }
  
  public disconnect() {
    this.socket.disconnect();
  }
}
